var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaxiStand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6319",
    "data-name": "Rectangle 6319",
    width: 42.078,
    height: 34.124,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34949",
    "data-name": "Group 34949",
    transform: "translate(-4755 -5407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6339",
    "data-name": "Rectangle 6339",
    transform: "translate(4755 5407)",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34869",
    "data-name": "Group 34869",
    transform: "translate(4771 5427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34868",
    "data-name": "Group 34868",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24366",
    "data-name": "Path 24366",
    d: "M0,3.015c.276-.342.484-.851.84-1A4.406,4.406,0,0,1,4.111,2a1.473,1.473,0,0,1,.843,1.522c-.007,2.341,0,4.683,0,7.025v.512c.175.009.308.021.44.021,1.082,0,2.164-.01,3.246.009a.511.511,0,0,0,.571-.373A16.756,16.756,0,0,1,20.33.684,17.051,17.051,0,1,1,9.207,23.421a.481.481,0,0,0-.528-.375c-1.109.021-2.218.007-3.327.009-.119,0-.238.015-.4.025v.506q0,3.451,0,6.9A1.662,1.662,0,0,1,3.09,32.366c-.438,0-.877-.006-1.315,0A1.649,1.649,0,0,1,.086,31.25.729.729,0,0,0,0,31.123V20.6c.218-.19.407-.473.66-.552.545-.172.984.27.985.928q0,4.622,0,9.242v.467H3.273V3.454H1.648v.483l0,9.036a3.067,3.067,0,0,1-.01.41.792.792,0,0,1-.607.7A.782.782,0,0,1,.184,13.8c-.069-.082-.123-.176-.184-.265V3.015m25.012-1.35A15.4,15.4,0,1,0,40.433,17.036,15.424,15.424,0,0,0,25.012,1.665m-16.5,11.1H4.981v8.6H8.513a17.334,17.334,0,0,1,0-8.6",
    transform: "translate(0 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24367",
    "data-name": "Path 24367",
    d: "M41.682,17.922A13.749,13.749,0,1,1,27.915,4.195,13.762,13.762,0,0,1,41.682,17.922m-1.647,0a12.1,12.1,0,1,0-12.1,12.1,12.112,12.112,0,0,0,12.1-12.1",
    transform: "translate(-2.909 -0.861)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24368",
    "data-name": "Path 24368",
    d: "M27.288,22.947a.8.8,0,0,1-.123,0c-.707-.109-1.207.038-1.382.862a.746.746,0,0,1-1.021.484.8.8,0,0,1-.485-1.065c.7-1.866,1.412-3.727,2.125-5.589a.889.889,0,0,1,.92-.615.949.949,0,0,1,.9.71q.95,2.53,1.9,5.059a5.323,5.323,0,0,1,.191.541.817.817,0,0,1-1.479.637.307.307,0,0,1-.056-.108c-.135-.9-.708-1.08-1.494-.913m-.506-1.688h1.01c-.172-.449-.324-.85-.506-1.325l-.5,1.325",
    transform: "translate(-4.967 -3.492)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24369",
    "data-name": "Path 24369",
    d: "M34.75,20.472c-.5-.707-.974-1.376-1.442-2.051a.831.831,0,1,1,1.335-.961c.367.509.724,1.024,1.114,1.578.389-.548.748-1.06,1.112-1.566a.833.833,0,0,1,1.231-.3.822.822,0,0,1,.118,1.233c-.411.6-.824,1.195-1.255,1.778a.4.4,0,0,0-.008.571c.518.705,1.014,1.428,1.515,2.147a.855.855,0,0,1-.114,1.3c-.416.28-.87.156-1.226-.344-.45-.632-.9-1.269-1.373-1.948l-1.207,1.71c-.1.134-.184.273-.289.4a.81.81,0,0,1-1.1.184.794.794,0,0,1-.234-1.118c.3-.472.638-.923.959-1.382l.862-1.229",
    transform: "translate(-6.725 -3.489)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24370",
    "data-name": "Path 24370",
    d: "M22.109,18.66c0,1.559,0,3.049,0,4.539a2.487,2.487,0,0,1-.022.449.819.819,0,0,1-.881.689.784.784,0,0,1-.734-.793c-.015-1.094-.007-2.188-.009-3.281v-1.6c-.266,0-.494.01-.721,0a.815.815,0,0,1-.838-.825.789.789,0,0,1,.838-.814q1.538-.017,3.076,0a.814.814,0,0,1,.861.8.839.839,0,0,1-.835.837c-.228.014-.458,0-.734,0",
    transform: "translate(-3.877 -3.489)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24371",
    "data-name": "Path 24371",
    d: "M41.413,20.671c0-.945-.006-1.89,0-2.835a.772.772,0,0,1,.6-.791.736.736,0,0,1,.867.306,1.126,1.126,0,0,1,.168.577q.019,2.753,0,5.505a.825.825,0,1,1-1.641-.01c-.012-.917,0-1.835,0-2.753h0",
    transform: "translate(-8.492 -3.489)",
    fill: "#353841"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiStand);
export default __webpack_public_path__ + "static/media/taxiStand.397036c14f43f3d72da2a359f4ea8330.svg";
export { ForwardRef as ReactComponent };